import OpticksSvgElement from "@/components/ui/OpticksSvgElement/OpticksSvgElement";
import type { OpticksSvgElementProps } from "@/components/ui/OpticksSvgElement/OpticksSvgElement.types";

// Collection: Non-Tabler Icons (Special Icon)
const OpticksLoader = ({
  className,
  width = 60,
  height = 66,
  viewBox = "0 0 60 66",
}: OpticksSvgElementProps) => (
  <OpticksSvgElement
    className={className}
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M60 0H0V66H60V0ZM15.0814 24.3868L30 15.7735L44.9186 24.3868V41.6133L30 50.2265L15.0814 41.6133V24.3868ZM29 10.5774C29.6188 10.2201 30.3812 10.2201 31 10.5774L48.9186 20.9226C49.5374 21.2799 49.9186 21.9402 49.9186 22.6547V43.3453C49.9186 44.0598 49.5374 44.7201 48.9186 45.0774L31 55.4226C30.3812 55.7799 29.6188 55.7799 29 55.4226L11.0814 45.0774C10.4626 44.7201 10.0814 44.0598 10.0814 43.3453V22.6547C10.0814 21.9402 10.4626 21.2799 11.0814 20.9226L29 10.5774Z"
      fill="white"
    />
  </OpticksSvgElement>
);

export default OpticksLoader;
